const styles = (theme) => ({
  root: {
    padding: `0 ${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`,
    border: `1px solid ${theme.palette.border.light}`,
    [theme.breakpoints.up('md')]: {
      padding: 0,
      border: 'none',
    },
  },
  negativeTopMargin: {
    [theme.breakpoints.up('md')]: {
      marginTop: '-30px',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: '10px',
    marginBottom: '10px',
  },
  contentRow: {
    width: '100%',
  },
  iconFieldWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    paddingBottom: '20px',
    paddingTop: '20px',
    position: 'relative',
    borderTop: `1px solid ${theme.palette.border.light}`,
    flexGrow: 1,
    '&:last-child': {
      paddingBottom: 0,
    },
    '& a': {
      textDecoration: 'none',
    },
    [theme.breakpoints.up('lg')]: {
      width: '50%',
    },
  },
  iconFieldSubWrapper: {
    width: '75%',
    [theme.breakpoints.up('lg')]: {
      width: '50%',
    },
  },
  toggleWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    width: '25%',
    [theme.breakpoints.up('lg')]: {
      justifyContent: 'flex-start',
      width: '50%',
    },
  },
  label: {
    color: theme.palette.text.dark,
    fontWeight: 600,
    fontFamily: 'Calibre',
    lineHeight: '1rem',
    marginBottom: 5,
    fontSize: '17px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '21px',
    },
  },
  value: {
    fontSize: '18px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '20px',
    },
  },
  icon: {
    background: theme.palette.background.lighter,
    padding: theme.spacing.unit,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.border.lighter,
    borderRadius: '100px',
    marginRight: theme.spacing.unit * 2,
    width: '42px',
    height: '42px',
    color: theme.palette.custom.notifications,
    [theme.breakpoints.up('md')]: {
      width: '50px',
      height: '50px',
    },
  },
  line: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  avatar: {
    color: theme.palette.custom.notifications,
    marginTop: '0px',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
    },
  },
  divider: {
    color: theme.palette.border.light,
  },
});

export default styles;
